module.exports = __webpack_public_path__ + "img/CRUZAMENTO_INDUSTRIAL.18c3ee9d.jpeg";